import React from "react";

type IconProps = {
    className?: string;
};

export const FinishIcon = ({ className }: IconProps) => {
    return (
        <svg
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <mask
                id="mask0_244_1740"
                style={{ maskType: "alpha" }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="48"
                height="48"
            >
                <rect width="48" height="48" fill="white" />
            </mask>
            <g mask="url(#mask0_244_1740)">
                <path
                    d="M15.2498 26.5834V39.6251C15.2498 40.2015 15.0667 40.665 14.7006 41.0155C14.3348 41.3663 13.8904 41.5418 13.3673 41.5418C12.789 41.5418 12.3262 41.3663 11.979 41.0155C11.6317 40.665 11.4581 40.2015 11.4581 39.6251V10.0001C11.4581 9.45482 11.6335 8.99913 11.9844 8.63302C12.3349 8.26663 12.7984 8.08344 13.3748 8.08344H36.8748C37.2726 8.08344 37.6013 8.16413 37.861 8.32552C38.1208 8.48691 38.332 8.71066 38.4948 8.99677C38.6295 9.28288 38.7127 9.58913 38.7444 9.91552C38.7758 10.2419 38.722 10.5479 38.5831 10.8334L35.3331 17.3334L38.5831 23.8334C38.722 24.1468 38.7688 24.4666 38.7235 24.793C38.678 25.1194 38.5879 25.4214 38.4531 25.6989C38.2904 25.9764 38.086 26.1932 37.8402 26.3493C37.5944 26.5054 37.2726 26.5834 36.8748 26.5834H15.2498Z"
                    fill="currentColor"
                />
            </g>
        </svg>
    );
};
